import { render, staticRenderFns } from "./queryAll.vue?vue&type=template&id=707d27fe&scoped=true"
import script from "./queryAll.vue?vue&type=script&lang=js"
export * from "./queryAll.vue?vue&type=script&lang=js"
import style0 from "./queryAll.vue?vue&type=style&index=0&id=707d27fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d27fe",
  null
  
)

export default component.exports